<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <template>
      <el-tabs v-model="activeName">
        <el-tab-pane label="商品列表" name="first">
          <div class="x-miss-addbox"><el-button type="primary" @click="dialogFormVisible=true;isnew = true;
          isold = false;"  style="padding:15px;"><span class="x-ac-addbtn"></span>添加商品</el-button></div>
          <template>
            <el-table :data="tableData1" border style="width: 100%">
              <el-table-column prop="date" label="商品标题" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="金币数" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <span class="x-bianji" @click="goedit(scope.row.title,scope.row.price,scope.row.id)">编辑</span>
                  <span @click.stop="removetablelist(scope.row.id,scope.row.title)" class="x-ac-remove">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
        <el-tab-pane label="订单列表" name="second">
          <template>
            <el-table :data="tableData2" border style="width: 100%">
              <el-table-column prop="date" label="商品标题" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="金币数" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="用户名" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.username }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="手机号" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="部门" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.bread }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <span class="x-bianji" @click="seenowok(scope.row.id)">标记为已完成</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
        <el-tab-pane label="已完成列表" name="third">
          <template>
            <el-table :data="tableData3" border style="width: 100%">
              <el-table-column prop="date" label="商品标题" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="金币数" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="用户名" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.username }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="手机号" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="部门" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.bread }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="状态">
                <template slot-scope="scope">
                  <span class="x-bianji">已完成</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <!--  -->
    <el-dialog title="添加商品" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="商品名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="金币数">
          <el-input v-model="form.iconnum" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="goadd" v-if="isnew">确 定</el-button>
        <el-button type="primary" @click="okedit" v-if="isold">编 辑</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'shoping',
  data () {
    return {
      activeName:'first',
      tableData1:[],
      dialogFormVisible:false,
      form:{
        name:'',
        iconnum:''
      },
      isnew:false,
      isold:false,
      editid:'',
      tableData2:[],
      tableData3:[]

    }
  },
  created() {

  },
  mounted(){
    this.gettable1()
    this.gettable2()
    this.gettable3()
  },
  methods:{
    gettable1:function(){
      axios.get('/admin/shop/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableData1 = response.data.data;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    gettable2:function(){
      axios.get('/admin/shop/orderList', {
        params: {
          sec: localStorage.token,
          type:1
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableData2 = response.data.data;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    gettable3:function(){
      axios.get('/admin/shop/orderList', {
        params: {
          sec: localStorage.token,
          type:2
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.tableData3 = response.data.data;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    goadd:function(){
      this.isnew = true;
      this.isold = false;
      axios.get('/admin/shop/add', {
        params: {
          sec: localStorage.token,
          title:this.form.name,
          price:this.form.iconnum
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
          this.form.name='';
          this.form.iconnum='';
          this.dialogFormVisible = false;
            this.$message({
              showClose: true,
              message:'添加成功',
              type: 'success'
            });
            this.gettable1()//加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //编辑回显
    goedit:function(title,price,id){
      this.isnew = false;
      this.isold = true;
      this.dialogFormVisible = true;
      this.form.name=title;
      this.form.iconnum=price;
      this.editid = id;
    },
    //确认编辑
    okedit:function(){
      axios.get('/admin/shop/edit', {
        params: {
          sec: localStorage.token,
          title:this.form.name,
          price:this.form.iconnum,
          id:this.editid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
          this.form.name='';
          this.form.iconnum='';
          this.dialogFormVisible = false;
          this.$message({
            showClose: true,
            message:'编辑成功',
            type: 'success'
          });
          this.gettable1()//加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 删除
    removetablelist(missionid,missiontitle){
      this.$confirm('确定要删除“'+missiontitle+'”吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.get('/admin/shop/del', {
            params: {
              sec: localStorage.token,
              id:missionid
            }
          })
          .then(function (response) {
            console.log(response);
            if(response.data.status == 1){
              this.gettable1()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                showClose: true,
                message:response.data.msg ,
                type: 'error'
              });
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
        }).catch(() => {

        });
    },
    //标记
    seenowok:function(id){
      axios.get('/admin/shop/pay', {
        params: {
          sec: localStorage.token,
          id:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
          this.$message({
            showClose: true,
            message:'标记成功',
            type: 'success'
          });
          this.gettable2()//加载列表
          this.gettable3()//加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style>
  .x-miss-tabbox .el-tabs__item{
    font-size: 16px;
  }.x-miss-tabbox .el-tabs__nav-wrap::after{
    height: 0;
  }.x-miss-tabbox .el-tabs__nav-wrap{
    margin-left: 10px;
  }.x-pagination{
    margin-top: 20px;
  }.x-misscenlist-box .el-table th.is-leaf{
    text-align: center;
  }.x-misscenlist-box .el-table thead tr th{
    background-color: #F2F2F2;
  }.x-misscenlist-box .el-table td{
    text-align: center;
  }.x-misscenlist-box .el-tabs__nav-wrap::after{
    height: 0;
  }.x-text-see{
    color: #BDA17A;
    text-decoration: none;

  }.x-ac-remove {
      background: url(../images/change.png)no-repeat;
      background-size: contain;
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      padding-left: 25px;
      margin-right: 20px;
  }.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
    cursor: pointer;
  }.x-miss-addbox{
    text-align: left;
    margin-bottom: 15px;
  }.el-form-item__content{
    text-align: left;
  }.x-all-btn {
      margin: 30px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn {
      background-color: #BDA17A;
      font-size: 14px;
      color: #fff;
      text-align: center;
      height: 44px;
      line-height: 44px;
      width: 126px;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      margin-right: 20px;
      z-index: 0;
  }.x-btn-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn-right .x-search-input{
    width: auto;
    margin-right: 10px;
    /* float: left; */
  }.x-miss-li{
    color: #333;
    cursor: pointer;
  }.x-bianji{
    /* background: url(../images/change.png)no-repeat; */
    background-size: contain;
    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 20px;
    display: initial;
    color: #BDA17A;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoping.vue